// extracted by mini-css-extract-plugin
export var btnCaption = "Home-module--btnCaption--d6d3b";
export var buttonGroup = "Home-module--buttonGroup--d84c6";
export var content = "Home-module--content--1caa3";
export var diagonalFrosting = "Home-module--diagonalFrosting--074f3";
export var headingText = "Home-module--headingText--0a964";
export var headline = "Home-module--headline--42272";
export var imageWrapper = "Home-module--imageWrapper--19560";
export var logo = "Home-module--logo--e4d52";
export var main = "Home-module--main--ef8d7";
export var mediaContainer = "Home-module--mediaContainer--a18b9";
export var quizBtn = "Home-module--quizBtn--4792e";
export var signuUpFormWrapper = "Home-module--signuUpFormWrapper--ed03f";
export var storySectionHeadline = "Home-module--storySectionHeadline--402f6";
export var wrapper = "Home-module--wrapper--0d7b9";